<template>
    <div class="reg-info-create">
        <div class="order-num">
            <span>订单号：</span><span>{{ reg_order_num }}</span>
        </div>
        <el-divider><span class="divider-con">客户注册信息采集表</span></el-divider>
        <div style="display: flex;" class="card-container">
            <div style="width: 90%;">
                <el-form :model="regInfoForm" :rules="rules" ref="regInfoForm" label-width="0px">
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">业务员和公司名称</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('title') === -1" type="success" size="mini"
                                @click="showEditForm('title')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('title') === -1" class="card-body-fir">
                                        <div>
                                            <el-tag type="warning" effect="dark" style="font-size: medium;">
                                                {{ show.name ? show.name : '业务员名称暂无' }}
                                            </el-tag>
                                            &nbsp;&nbsp;<span style="font-size: medium;"> - </span>&nbsp;&nbsp;
                                            <el-tag type="primary" effect="dark" style="font-size: medium;">
                                                {{ regInfoForm.company_name ? regInfoForm.company_name : '公司名称暂无' }}
                                            </el-tag>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <!-- <el-input style="width: 30%;" v-model="regInfoForm.hero"
                                                    placeholder="请输入业务员"></el-input> &nbsp;&nbsp;-&nbsp;&nbsp; -->
                                            <el-form-item label="" style="width: 30%;">
                                                <admin-user @choosed="handleChooseAdminUser" :load="true"
                                                    :ids="show.hero" size="large" />
                                            </el-form-item>
                                            <el-form-item>
                                                &nbsp;&nbsp;-&nbsp;&nbsp;
                                            </el-form-item>
                                            <el-form-item label="" prop="company_name" style="flex-grow: 1;">
                                                <el-input v-model.trim="regInfoForm.company_name" placeholder="请输入公司名称"
                                                    clearable></el-input>
                                            </el-form-item>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('title')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'title')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">收件地址</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('rec_address') === -1" type="success" size="mini"
                                @click="showEditForm('rec_address')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('rec_address') === -1" class="card-body-fir">
                                        <div style="display: flex;align-items: flex-end;">
                                            <el-tag type="primary" effect="dark" style="font-size: medium;">
                                                {{ regInfoForm.rec_address ? regInfoForm.rec_address : '收件地址暂无' }}
                                            </el-tag>
                                            <copy-some v-if="regInfoForm.rec_address" :v="regInfoForm.rec_address"
                                                color="" />
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <el-form-item label="" prop="rec_address" style="flex-grow: 1;">
                                                <el-input v-model="regInfoForm.rec_address" placeholder="请输入收件地址"
                                                    type="textarea" autosize></el-input>
                                            </el-form-item>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('rec_address')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'rec_address')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">公司（企业）名称</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('company_name') === -1" type="success" size="mini"
                                @click="showEditForm('company_name')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('company_name') === -1" class="card-body-fir">
                                        <table id="show-table" border>
                                            <thead>
                                                <tr>
                                                    <th class="t-title">行政区划</th>
                                                    <th class="t-title">字号②</th>
                                                    <th class="t-title">行业特点③</th>
                                                    <th class="t-title">组织形式④</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="JSON.stringify(computedData) === '{}'">
                                                    <td colspan="4" class="centered"> 数据为空 </td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in pre_company" :key="index">
                                                    <td class="centered">
                                                        {{ item.district }}
                                                    </td>
                                                    <td class="centered">
                                                        {{ item.special_sigan }}
                                                    </td>
                                                    <td class="centered">
                                                        {{ item.industry }}
                                                    </td>
                                                    <td class="centered">
                                                        {{ item.organizational }}
                                                    </td>
                                                    <td class="no-border"
                                                        v-if="item.district || item.industry || item.special_sigan || item.organizational">
                                                        <copy-some
                                                            :v="`${item.district || ''}${item.special_sigan || ''}${item.industry || ''}${item.organizational || ''}`"
                                                            color="" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table id="field-table" border>
                                                <thead>
                                                    <tr>
                                                        <th class="t-title">行政区划</th>
                                                        <th class="t-title">字号②</th>
                                                        <th class="t-title">行业特点③</th>
                                                        <th class="t-title">组织形式④</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                prop="pre_company_name.default.district"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.pre_company_name.default.district"
                                                                    placeholder="请输入行政区划" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                prop="pre_company_name.default.special_sigan"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.pre_company_name.default.special_sigan"
                                                                    placeholder="请输入字号" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                prop="pre_company_name.default.industry"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.pre_company_name.default.industry"
                                                                    placeholder="请输入行业特点" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                prop="pre_company_name.default.organizational"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.pre_company_name.default.organizational"
                                                                    placeholder="请输入组织形式" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="no-border">
                                                            <div>
                                                                <el-button
                                                                    v-if="!regInfoForm.pre_company_name.domians.length"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddForm(0)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(item, index) in regInfoForm.pre_company_name.domians"
                                                        :key="index">
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`pre_company_name.domians.${index}.district`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.district" placeholder="请输入行政区划"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`pre_company_name.domians.${index}.special_sigan`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.special_sigan"
                                                                    placeholder="请输入字号" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`pre_company_name.domians.${index}.industry`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.industry" placeholder="请输入行业特点"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`pre_company_name.domians.${index}.organizational`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.organizational"
                                                                    placeholder="请输入组织形式" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered no-border">
                                                            <div style="display: flex;">
                                                                <el-button
                                                                    v-if="regInfoForm.pre_company_name.domians.length === index + 1"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddForm(index)"></el-button>
                                                                <el-button circle size="mini" type="info"
                                                                    icon="el-icon-minus"
                                                                    @click="handleRemoveForm(index)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('company_name')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'company_name')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">经营范围</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('scope') === -1" type="success" size="mini"
                                @click="showEditForm('scope')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('scope') === -1" class="card-body-fir">
                                        <table class="scope-table" border>
                                            <tbody>
                                                <tr>
                                                    <td class="centered sco-bg">
                                                        范围编码:
                                                    </td>
                                                    <td class="centered">
                                                        {{ regInfoForm.business_scope_tag }}
                                                    </td>
                                                    <td class="no-border" v-if="regInfoForm.business_scope_tag">
                                                        <copy-some :v="regInfoForm.business_scope_tag" color="" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="centered sco-bg">
                                                        经营范围:
                                                    </td>
                                                    <td class="centered">
                                                        {{ regInfoForm.business_scope_desc }}
                                                    </td>
                                                    <td class="no-border" v-if="regInfoForm.business_scope_desc">
                                                        <copy-some :v="regInfoForm.business_scope_desc" color="" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="scope-table-edit" border>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered sco-bg">
                                                            范围编码:
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="business_scope_tag"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.business_scope_tag"
                                                                    placeholder="请输入范围编码" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="centered sco-bg">
                                                            经营范围:
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="business_scope_desc"
                                                                style="flex-grow: 1;">
                                                                <el-input v-model="regInfoForm.business_scope_desc"
                                                                    placeholder="请输入经营范围" type="textarea"
                                                                    :autosize="{ minRows: 3 }"></el-input>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('scope')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'scope')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">注册资金</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('reg_capital') === -1" type="success" size="mini"
                                @click="showEditForm('reg_capital')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('reg_capital') === -1" class="card-body-fir">
                                        <table class="reg-capital-table" border>
                                            <tbody>
                                                <tr>
                                                    <td class="centered sco-bg">
                                                        注册资金（出资总额）:
                                                    </td>
                                                    <td class="centered">
                                                        {{ regInfoForm.reg_capital }}
                                                    </td>
                                                    <td class="no-border" v-if="regInfoForm.reg_capital">
                                                        <copy-some :v="regInfoForm.reg_capital" color="" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="reg-capital-edit" border>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered sco-bg">
                                                            注册资金（出资总额）:
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="reg_capital"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 1, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.reg_capital"
                                                                    placeholder="请输入注册资金" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('reg_capital')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'reg_capital')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">法人【有限公司、集团公司、股份公司】</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('corporation') === -1" type="success" size="mini"
                                @click="showEditForm('corporation')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('corporation') === -1" class="card-body-fir">
                                        <table class="corporation-table" border>
                                            <thead>
                                                <tr>
                                                    <th class="t-title">姓名</th>
                                                    <th class="t-title">实名制手机</th>
                                                    <th class="t-title">身份证号</th>
                                                    <th class="t-title">邮箱</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="JSON.stringify(computedData) === '{}'">
                                                    <td colspan="4" class="centered"> 数据为空 </td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in corporation" :key="index">
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.name }}</span>
                                                            <copy-some v-if="item.name" style="margin-left:auto"
                                                                :v="`${item.name || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.phone }}</span>
                                                            <copy-some v-if="item.phone" style="margin-left:auto"
                                                                :v="`${item.phone || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.id_card }}</span>
                                                            <copy-some v-if="item.id_card" style="margin-left:auto"
                                                                :v="`${item.id_card || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.email }}</span>
                                                            <copy-some v-if="item.email" style="margin-left:auto"
                                                                :v="`${item.email || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="corporation-table-edit" border>
                                                <thead>
                                                    <tr>
                                                        <th class="t-title">姓名</th>
                                                        <th class="t-title">实名制手机</th>
                                                        <th class="t-title">身份证号</th>
                                                        <th class="t-title">邮箱</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="corporation.default.name"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.corporation.default.name"
                                                                    placeholder="请输入姓名" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="corporation.default.phone"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.corporation.default.phone"
                                                                    placeholder="请输入手机号" clearable maxlength="11"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="corporation.default.id_card"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.corporation.default.id_card"
                                                                    placeholder="请输入身份证号" clearable maxlength="18"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="corporation.default.email"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.corporation.default.email"
                                                                    placeholder="请输入邮箱" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="no-border">
                                                            <div>
                                                                <el-button
                                                                    v-if="!regInfoForm.corporation.domians.length"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddCorporationForm(0)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(item, index) in regInfoForm.corporation.domians"
                                                        :key="index">
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`corporation.domians.${index}.name`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.name" placeholder="请输入姓名"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`corporation.domians.${index}.phone`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.phone" placeholder="请输入手机号"
                                                                    clearable maxlength="11" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`corporation.domians.${index}.id_card`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.id_card" placeholder="请输入身份证号"
                                                                    clearable maxlength="18" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`corporation.domians.${index}.email`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.email" placeholder="请输入邮箱"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered no-border">
                                                            <div style="display: flex;">
                                                                <el-button
                                                                    v-if="regInfoForm.corporation.domians.length === index + 1"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddCorporationForm(index)"></el-button>
                                                                <el-button circle size="mini" type="info"
                                                                    icon="el-icon-minus"
                                                                    @click="handleRemoveCorporationForm(index)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('corporation')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'corporation')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">监事信息【有限公司、集团公司、股份公司填写】</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('supervisor') === -1" type="success" size="mini"
                                @click="showEditForm('supervisor')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('supervisor') === -1" class="card-body-fir">
                                        <table class="corporation-table" border>
                                            <thead>
                                                <tr>
                                                    <th class="t-title">姓名</th>
                                                    <th class="t-title">实名制手机</th>
                                                    <th class="t-title">身份证号</th>
                                                    <th class="t-title">邮箱</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="JSON.stringify(computedData) === '{}'">
                                                    <td colspan="4" class="centered"> 数据为空 </td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in supervisor" :key="index">
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.name }}</span>
                                                            <copy-some v-if="item.name" style="margin-left:auto"
                                                                :v="`${item.name || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.phone }}</span>
                                                            <copy-some v-if="item.phone" style="margin-left:auto"
                                                                :v="`${item.phone || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.id_card }}</span>
                                                            <copy-some v-if="item.id_card" style="margin-left:auto"
                                                                :v="`${item.id_card || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.email }}</span>
                                                            <copy-some v-if="item.email" style="margin-left:auto"
                                                                :v="`${item.email || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="corporation-table-edit" border>
                                                <thead>
                                                    <tr>
                                                        <th class="t-title">姓名</th>
                                                        <th class="t-title">实名制手机</th>
                                                        <th class="t-title">身份证号</th>
                                                        <th class="t-title">邮箱</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisor.default.name"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.supervisor.default.name"
                                                                    placeholder="请输入姓名" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisor.default.phone"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.supervisor.default.phone"
                                                                    placeholder="请输入手机号" clearable maxlength="11"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisor.default.id_card"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.supervisor.default.id_card"
                                                                    placeholder="请输入身份证号" clearable maxlength="18"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisor.default.email"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.supervisor.default.email"
                                                                    placeholder="请输入邮箱" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="no-border">
                                                            <div>
                                                                <el-button v-if="!regInfoForm.supervisor.domians.length"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddSupervisorForm(0)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(item, index) in regInfoForm.supervisor.domians"
                                                        :key="index">
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisor.domians.${index}.name`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.name" placeholder="请输入姓名"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisor.domians.${index}.phone`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.phone" placeholder="请输入手机号"
                                                                    clearable maxlength="11" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisor.domians.${index}.id_card`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.id_card" placeholder="请输入身份证号"
                                                                    clearable maxlength="18" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisor.domians.${index}.email`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.email" placeholder="请输入邮箱"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered no-border">
                                                            <div style="display: flex;">
                                                                <el-button
                                                                    v-if="regInfoForm.supervisor.domians.length === index + 1"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddSupervisorForm(index)"></el-button>
                                                                <el-button circle size="mini" type="info"
                                                                    icon="el-icon-minus"
                                                                    @click="handleRemoveSupervisorForm(index)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('supervisor')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'supervisor')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">股东信息及出资比例（若是个人独资，则无需填写）</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('shareholder') === -1" type="success" size="mini"
                                @click="showEditForm('shareholder')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('shareholder') === -1" class="card-body-fir">
                                        <table class="corporation-table" border>
                                            <thead>
                                                <tr>
                                                    <th class="t-title">姓名</th>
                                                    <th class="t-title">实名制手机</th>
                                                    <th class="t-title">身份证号</th>
                                                    <th class="t-title">邮箱</th>
                                                    <th class="t-title">出资比例</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="JSON.stringify(computedData) === '{}'">
                                                    <td colspan="5" class="centered"> 数据为空 </td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in shareholder" :key="index">
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.name }}</span>
                                                            <copy-some v-if="item.name" style="margin-left:auto"
                                                                :v="`${item.name || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.phone }}</span>
                                                            <copy-some v-if="item.phone" style="margin-left:auto"
                                                                :v="`${item.phone || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.id_card }}</span>
                                                            <copy-some v-if="item.id_card" style="margin-left:auto"
                                                                :v="`${item.id_card || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.email }}</span>
                                                            <copy-some v-if="item.email" style="margin-left:auto"
                                                                :v="`${item.email || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.contribution }}<i
                                                                    v-if="item.contribution">%</i></span>
                                                            <copy-some v-if="item.contribution" style="margin-left:auto"
                                                                :v="`${item.contribution || ''}%`" color="" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="corporation-table-edit" border>
                                                <thead>
                                                    <tr>
                                                        <th class="t-title">姓名</th>
                                                        <th class="t-title">实名制手机</th>
                                                        <th class="t-title">身份证号</th>
                                                        <th class="t-title">邮箱</th>
                                                        <th class="t-title">出资比例</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="shareholder.default.name"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.shareholder.default.name"
                                                                    placeholder="请输入姓名" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="shareholder.default.phone"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.shareholder.default.phone"
                                                                    placeholder="请输入手机号" clearable maxlength="11"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="shareholder.default.id_card"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.shareholder.default.id_card"
                                                                    placeholder="请输入身份证号" clearable maxlength="18"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="shareholder.default.email"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.shareholder.default.email"
                                                                    placeholder="请输入邮箱" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                prop="shareholder.default.contribution"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^(?:100(?:\.0+)?|[1-9]?\d(?:\.\d+)?)$/, message: '输入0-100之间的数字(含小数)！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.shareholder.default.contribution"
                                                                    placeholder="请输入出资比例" clearable><template
                                                                        slot="append">%</template></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="no-border">
                                                            <div>
                                                                <el-button
                                                                    v-if="!regInfoForm.shareholder.domians.length"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddShareholderForm(0)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(item, index) in regInfoForm.shareholder.domians"
                                                        :key="index">
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`shareholder.domians.${index}.name`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.name" placeholder="请输入姓名"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`shareholder.domians.${index}.phone`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.phone" placeholder="请输入手机号"
                                                                    clearable maxlength="11" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`shareholder.domians.${index}.id_card`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.id_card" placeholder="请输入身份证号"
                                                                    clearable maxlength="18" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`shareholder.domians.${index}.email`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.email" placeholder="请输入邮箱"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`shareholder.domians.${index}.contribution`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^(?:100(?:\.0+)?|[1-9]?\d(?:\.\d+)?)$/, message: '输入0-100之间的数字(含小数)！', trigger: 'blur' }]">
                                                                <el-input v-model="item.contribution"
                                                                    placeholder="请输入出资比例" clearable><template
                                                                        slot="append">%</template></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered no-border">
                                                            <div style="display: flex;">
                                                                <el-button
                                                                    v-if="regInfoForm.shareholder.domians.length === index + 1"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddShareholderForm(index)"></el-button>
                                                                <el-button circle size="mini" type="info"
                                                                    icon="el-icon-minus"
                                                                    @click="handleRemoveShareholderForm(index)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('shareholder')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'shareholder')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">财务信息【有限公司、集团公司、股份公司】</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('finance') === -1" type="success" size="mini"
                                @click="showEditForm('finance')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('finance') === -1" class="card-body-fir">
                                        <table class="corporation-table" border>
                                            <thead>
                                                <tr>
                                                    <th class="t-title">姓名</th>
                                                    <th class="t-title">实名制手机</th>
                                                    <th class="t-title">身份证号</th>
                                                    <th class="t-title">邮箱</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="JSON.stringify(computedData) === '{}'">
                                                    <td colspan="4" class="centered"> 数据为空 </td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in finance" :key="index">
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.name }}</span>
                                                            <copy-some v-if="item.name" style="margin-left:auto"
                                                                :v="`${item.name || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.phone }}</span>
                                                            <copy-some v-if="item.phone" style="margin-left:auto"
                                                                :v="`${item.phone || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.id_card }}</span>
                                                            <copy-some v-if="item.id_card" style="margin-left:auto"
                                                                :v="`${item.id_card || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.email }}</span>
                                                            <copy-some v-if="item.email" style="margin-left:auto"
                                                                :v="`${item.email || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="corporation-table-edit" border>
                                                <thead>
                                                    <tr>
                                                        <th class="t-title">姓名</th>
                                                        <th class="t-title">实名制手机</th>
                                                        <th class="t-title">身份证号</th>
                                                        <th class="t-title">邮箱</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="finance.default.name"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.finance.default.name"
                                                                    placeholder="请输入姓名" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="finance.default.phone"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.finance.default.phone"
                                                                    placeholder="请输入手机号" clearable maxlength="11"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="finance.default.id_card"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.finance.default.id_card"
                                                                    placeholder="请输入身份证号" clearable maxlength="18"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="finance.default.email"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="regInfoForm.finance.default.email"
                                                                    placeholder="请输入邮箱" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="no-border">
                                                            <div>
                                                                <el-button v-if="!regInfoForm.finance.domians.length"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddFinanceForm(0)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(item, index) in regInfoForm.finance.domians"
                                                        :key="index">
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`finance.domians.${index}.name`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.name" placeholder="请输入姓名"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`finance.domians.${index}.phone`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.phone" placeholder="请输入手机号"
                                                                    clearable maxlength="11" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`finance.domians.${index}.id_card`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.id_card" placeholder="请输入身份证号"
                                                                    clearable maxlength="18" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`finance.domians.${index}.email`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.email" placeholder="请输入邮箱"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered no-border">
                                                            <div style="display: flex;">
                                                                <el-button
                                                                    v-if="regInfoForm.finance.domians.length === index + 1"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddFinanceForm(index)"></el-button>
                                                                <el-button circle size="mini" type="info"
                                                                    icon="el-icon-minus"
                                                                    @click="handleRemoveFinanceForm(index)"></el-button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('finance')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'finance')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">董事会成员（五名、股份公司填写）</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('board_members') === -1" type="success" size="mini"
                                @click="showEditForm('board_members')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('board_members') === -1" class="card-body-fir">
                                        <table class="corporation-table" border>
                                            <thead>
                                                <tr>
                                                    <th class="t-title">姓名</th>
                                                    <th class="t-title">实名制手机</th>
                                                    <th class="t-title">身份证号</th>
                                                    <th class="t-title">邮箱</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="JSON.stringify(computedData) === '{}'">
                                                    <td colspan="4" class="centered"> 数据为空 </td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in board_members" :key="index">
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.name }}</span>
                                                            <copy-some v-if="item.name" style="margin-left:auto"
                                                                :v="`${item.name || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.phone }}</span>
                                                            <copy-some v-if="item.phone" style="margin-left:auto"
                                                                :v="`${item.phone || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.id_card }}</span>
                                                            <copy-some v-if="item.id_card" style="margin-left:auto"
                                                                :v="`${item.id_card || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.email }}</span>
                                                            <copy-some v-if="item.email" style="margin-left:auto"
                                                                :v="`${item.email || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="corporation-table-edit" border>
                                                <thead>
                                                    <tr>
                                                        <th class="t-title">姓名</th>
                                                        <th class="t-title">实名制手机</th>
                                                        <th class="t-title">身份证号</th>
                                                        <th class="t-title">邮箱</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="board_members.default.name"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.board_members.default.name"
                                                                    placeholder="请输入姓名" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="board_members.default.phone"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.board_members.default.phone"
                                                                    placeholder="请输入手机号" clearable maxlength="11"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="board_members.default.id_card"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.board_members.default.id_card"
                                                                    placeholder="请输入身份证号" clearable maxlength="18"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="board_members.default.email"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.board_members.default.email"
                                                                    placeholder="请输入邮箱" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <!-- <td class="no-border">
                                                            <div>
                                                                <el-button v-if="!regInfoForm.finance.domians.length"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddFinanceForm(0)"></el-button>
                                                            </div>
                                                        </td> -->
                                                    </tr>
                                                    <tr v-for="(item, index) in regInfoForm.board_members.domians"
                                                        :key="index">
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`board_members.domians.${index}.name`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.name" placeholder="请输入姓名"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`board_members.domians.${index}.phone`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.phone" placeholder="请输入手机号"
                                                                    clearable maxlength="11" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`board_members.domians.${index}.id_card`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.id_card" placeholder="请输入身份证号"
                                                                    clearable maxlength="18" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`board_members.domians.${index}.email`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.email" placeholder="请输入邮箱"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <!-- <td class="centered no-border">
                                                            <div style="display: flex;">
                                                                <el-button
                                                                    v-if="regInfoForm.finance.domians.length === index + 1"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddFinanceForm(index)"></el-button>
                                                                <el-button circle size="mini" type="info"
                                                                    icon="el-icon-minus"
                                                                    @click="handleRemoveFinanceForm(index)"></el-button>
                                                            </div>
                                                        </td> -->
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('board_members')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'board_members')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                    <qyh-card class="qc-mb">
                        <template v-slot:title>
                            <span class="title-sec">监事会成员（两名、股份公司填写）</span>
                        </template>
                        <template v-slot:edit>
                            <el-button v-if="showIsShowBtn.indexOf('supervisory_board') === -1" type="success" size="mini"
                                @click="showEditForm('supervisory_board')">编辑</el-button>
                        </template>
                        <template v-slot:other>
                            <div>
                                <div class="card-body">
                                    <div v-if="isEdit.indexOf('supervisory_board') === -1" class="card-body-fir">
                                        <table class="corporation-table" border>
                                            <thead>
                                                <tr>
                                                    <th class="t-title">姓名</th>
                                                    <th class="t-title">实名制手机</th>
                                                    <th class="t-title">身份证号</th>
                                                    <th class="t-title">邮箱</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="JSON.stringify(computedData) === '{}'">
                                                    <td colspan="4" class="centered"> 数据为空 </td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in supervisory_board" :key="index">
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.name }}</span>
                                                            <copy-some v-if="item.name" style="margin-left:auto"
                                                                :v="`${item.name || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.phone }}</span>
                                                            <copy-some v-if="item.phone" style="margin-left:auto"
                                                                :v="`${item.phone || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.id_card }}</span>
                                                            <copy-some v-if="item.id_card" style="margin-left:auto"
                                                                :v="`${item.id_card || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                    <td class="centered">
                                                        <div class="copy-in-l">
                                                            <span style="margin: 0 auto">{{ item.email }}</span>
                                                            <copy-some v-if="item.email" style="margin-left:auto"
                                                                :v="`${item.email || ''}`" color="" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else>
                                        <div style="display: flex;">
                                            <table class="corporation-table-edit" border>
                                                <thead>
                                                    <tr>
                                                        <th class="t-title">姓名</th>
                                                        <th class="t-title">实名制手机</th>
                                                        <th class="t-title">身份证号</th>
                                                        <th class="t-title">邮箱</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisory_board.default.name"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.supervisory_board.default.name"
                                                                    placeholder="请输入姓名" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisory_board.default.phone"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.supervisory_board.default.phone"
                                                                    placeholder="请输入手机号" clearable maxlength="11"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisory_board.default.id_card"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.supervisory_board.default.id_card"
                                                                    placeholder="请输入身份证号" clearable maxlength="18"
                                                                    show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label="" prop="supervisory_board.default.email"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input
                                                                    v-model="regInfoForm.supervisory_board.default.email"
                                                                    placeholder="请输入邮箱" clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <!-- <td class="no-border">
                                                            <div>
                                                                <el-button v-if="!regInfoForm.finance.domians.length"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddFinanceForm(0)"></el-button>
                                                            </div>
                                                        </td> -->
                                                    </tr>
                                                    <tr v-for="(item, index) in regInfoForm.supervisory_board.domians"
                                                        :key="index">
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisory_board.domians.${index}.name`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ min: 2, max: 50, message: '输入长度不符！', trigger: 'blur' }]">
                                                                <el-input v-model="item.name" placeholder="请输入姓名"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisory_board.domians.${index}.phone`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.phone" placeholder="请输入手机号"
                                                                    clearable maxlength="11" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisory_board.domians.${index}.id_card`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.id_card" placeholder="请输入身份证号"
                                                                    clearable maxlength="18" show-word-limit></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <td class="centered">
                                                            <el-form-item label=""
                                                                :prop="`supervisory_board.domians.${index}.email`"
                                                                style="flex-grow: 1;"
                                                                :rules="[{ pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, message: '邮箱格式不正确！', trigger: 'blur' }]">
                                                                <el-input v-model="item.email" placeholder="请输入邮箱"
                                                                    clearable></el-input>
                                                            </el-form-item>
                                                        </td>
                                                        <!-- <td class="centered no-border">
                                                            <div style="display: flex;">
                                                                <el-button
                                                                    v-if="regInfoForm.finance.domians.length === index + 1"
                                                                    circle size="mini" type="primary"
                                                                    icon="el-icon-plus"
                                                                    @click="handleAddFinanceForm(index)"></el-button>
                                                                <el-button circle size="mini" type="info"
                                                                    icon="el-icon-minus"
                                                                    @click="handleRemoveFinanceForm(index)"></el-button>
                                                            </div>
                                                        </td> -->
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style="text-align: right; margin-top: 0.2rem">
                                            <el-button type="info" size="mini"
                                                @click="handleCancle('supervisory_board')">取消</el-button>
                                            <el-button type="primary" size="mini"
                                                @click="submitForm('regInfoForm', 'supervisory_board')">保存</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </qyh-card>
                </el-form>
            </div>
            <div style="width: 10%;">
                <p>1</p>
                <p>1</p>
                <p>1</p>
                <p>1</p>
                <p>1</p>
            </div>
        </div>
    </div>
</template>

<script>
import QyhCard from '../../commonReform/QyhCard';
import AdminUser from '../../commonReform/AdminUser';
import CryptoJS from 'crypto-js'
import CopySome from '../../commonReform/CopySome';
export default {
    name: 'RegInfoCreate',
    components: { QyhCard, AdminUser, CopySome },
    data() {
        return {
            addShow: null,
            isEditFlag: false,
            isEdit: [],
            showIsShowBtn: [],
            // 业务员和公司名称
            regInfoForm: {
                company_name: '',
                hero: [],
                id: null,
                rec_address: '',
                pre_company_name: {
                    domians: [],
                    default: {
                        district: '',
                        special_sigan: '',
                        industry: '',
                        organizational: ''
                    },
                },
                business_scope_tag: '',
                business_scope_desc: '',
                reg_capital: '',
                corporation: {
                    domians: [],
                    default: {
                        name: '',
                        phone: '',
                        id_card: '',
                        email: ''
                    },
                },
                supervisor: {
                    domians: [],
                    default: {
                        name: '',
                        phone: '',
                        id_card: '',
                        email: ''
                    },
                },
                shareholder: {
                    domians: [],
                    default: {
                        name: '',
                        phone: '',
                        id_card: '',
                        email: '',
                        contribution: ''
                    },
                },
                finance: {
                    domians: [],
                    default: {
                        name: '',
                        phone: '',
                        id_card: '',
                        email: ''
                    },
                },
                board_members: {
                    domians: [
                        {
                            name: '',
                            phone: '',
                            id_card: '',
                            email: ''
                        },
                        {
                            name: '',
                            phone: '',
                            id_card: '',
                            email: ''
                        },
                        {
                            name: '',
                            phone: '',
                            id_card: '',
                            email: ''
                        },
                        {
                            name: '',
                            phone: '',
                            id_card: '',
                            email: ''
                        },
                    ],
                    default: {
                        name: '',
                        phone: '',
                        id_card: '',
                        email: ''
                    },
                },
                supervisory_board: {
                    domians: [
                        {
                            name: '',
                            phone: '',
                            id_card: '',
                            email: ''
                        },
                    ],
                    default: {
                        name: '',
                        phone: '',
                        id_card: '',
                        email: ''
                    },
                },
            },
            pre_company: [],
            corporation: [],
            supervisor: [],
            shareholder: [],
            finance: [],
            board_members: [],
            supervisory_board: [],
            computedData: {},
            reg_order_id: null,
            reg_order_num: null,
            rules: {
                company_name: [
                    {
                        min: 5,
                        max: 50,
                        message: "长度不符!",
                        trigger: "blur",
                    },
                ],
                rec_address: [
                    {
                        min: 2,
                        max: 100,
                        message: "长度不符!",
                        trigger: "blur",
                    },
                ],
                business_scope_desc: [
                    {
                        min: 2,
                        max: 1000,
                        message: "长度不符!",
                        trigger: "blur",
                    },
                ],
                // name: [
                //     { required: true, message: "请输入姓名", trigger: "blur" },
                //     {
                //         min: 1,
                //         max: 20,
                //         message: "长度在 1 到 20 个字符",
                //         trigger: "blur",
                //     },
                // ],
                // phone: [
                //     { required: true, message: "请输入手机号", trigger: "blur" },
                //     { validator: checkPhone, trigger: "blur" },
                // ],
                // meetAt: [{ required: true, message: "请选择面试时间", trigger: "blur" }],
                // meet_place: [{ required: true, message: "请选择面试地点", trigger: "blur" }],
                // station: [
                //     {
                //         min: 1,
                //         max: 20,
                //         message: "长度在 1 到 20 个字符",
                //         trigger: "blur",
                //     },
                // ],
                // feishuurl: [
                //     {
                //         min: 1,
                //         max: 200,
                //         message: "长度在 1 到 200 个字符",
                //         trigger: "blur",
                //     },
                // ],
            },
        }
    },
    methods: {
        handleRemoveCorporationForm(index) {
            this.regInfoForm.corporation.domians.splice(index, 1)
        },
        handleAddCorporationForm(index) {
            this.regInfoForm.corporation.domians.splice(index + 1, 0, {
                name: '',
                phone: '',
                id_card: '',
                email: '',
            })
        },
        handleRemoveSupervisorForm(index) {
            this.regInfoForm.supervisor.domians.splice(index, 1)
        },
        handleAddSupervisorForm(index) {
            this.regInfoForm.supervisor.domians.splice(index + 1, 0, {
                name: '',
                phone: '',
                id_card: '',
                email: '',
            })
        },
        handleRemoveFinanceForm(index) {
            this.regInfoForm.finance.domians.splice(index, 1)
        },
        handleAddFinanceForm(index) {
            this.regInfoForm.finance.domians.splice(index + 1, 0, {
                name: '',
                phone: '',
                id_card: '',
                email: '',
            })
        },
        handleRemoveShareholderForm(index) {
            this.regInfoForm.shareholder.domians.splice(index, 1)
        },
        handleAddShareholderForm(index) {
            this.regInfoForm.shareholder.domians.splice(index + 1, 0, {
                name: '',
                phone: '',
                id_card: '',
                email: '',
                contribution: ''
            })
        },
        handleRemoveForm(index) {
            this.regInfoForm.pre_company_name.domians.splice(index, 1)
        },
        handleAddForm(index) {
            this.regInfoForm.pre_company_name.domians.splice(index + 1, 0, {
                district: '',
                special_sigan: '',
                industry: '',
                organizational: '',
            })
        },
        handleChooseAdminUser(val) {
            this.regInfoForm.hero = val
        },
        handleCancle(key) {
            let index_showIsShowBtn = this.showIsShowBtn.indexOf(key)
            if (index_showIsShowBtn !== -1) this.showIsShowBtn.splice(index_showIsShowBtn, 1)
            let index_isEdit = this.isEdit.indexOf(key)
            if (index_isEdit !== -1) this.isEdit.splice(index_isEdit, 1)
            this.loadTable()
        },
        showEditForm(key) {
            this.isEdit.push(key)
            this.showIsShowBtn.push(key)
        },
        submitForm(formName, flag) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this[formName].isEdit = this.isEditFlag
                    this[formName].order_id = this.reg_order_id
                    this.$axios
                        .post("api/api3_reg_info/store", this[formName])
                        .then((res) => {
                            const { data } = res;
                            if (data.code === 0) {
                                this.$message.success(data.msg);
                                // this.loadTable()
                                this.handleCancle(flag)
                                // this.$refs.categoryForm.resetFields();
                                // this.$bus.$emit("ysyclearrm");
                                // this.categoryIndrawer = false;
                                // this.loadTable();
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        loadTable() {
            this.$axios.get('api/api3_reg_info/index', {
                loadingClose: true,
                params: {
                    order_id: this.reg_order_id,
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.computedData = data.data
                    // 业务员和公司名称
                    this.regInfoForm.company_name = data.data.company_name
                    this.regInfoForm.hero = this.show.hero
                    this.regInfoForm.id = data.data.id
                    //收件地址
                    this.regInfoForm.rec_address = data.data.rec_address
                    // 公司（企业）名称
                    this.pre_company = data.data.pre_company
                    this.regInfoForm.pre_company_name = this.show.pre_company_name
                    // 经营范围
                    this.regInfoForm.business_scope_tag = data.data.business_scope_tag
                    this.regInfoForm.business_scope_desc = data.data.business_scope_desc
                    // 注册资本
                    this.regInfoForm.reg_capital = data.data.reg_capital
                    // 法人
                    this.corporation = data.data.corporation
                    this.regInfoForm.corporation = this.show.corporation
                    // 监事人
                    this.supervisor = data.data.supervisor
                    this.regInfoForm.supervisor = this.show.supervisor
                    // 股东
                    this.shareholder = data.data.shareholder
                    this.regInfoForm.shareholder = this.show.shareholder
                    // 法人
                    this.finance = data.data.finance
                    this.regInfoForm.finance = this.show.finance
                    // 董事会成员
                    this.board_members = data.data.board_members
                    this.regInfoForm.board_members = this.show.board_members
                    // 监事会成员
                    this.supervisory_board = data.data.supervisory_board
                    this.regInfoForm.supervisory_board = this.show.supervisory_board
                }
                this.isEditFlag = data.has
            }).catch()
        },
        initData() {
            try {
                var context = JSON.parse(this.$route.query.context)
            } catch (e) {
                this.$router.push('/not_fund')
            }

            this.deCryptData(context.keywords, context.id, context.num)
            this.reg_order_id = context.id
            this.reg_order_num = context.num
            this.loadTable()

        },
        deCryptData(val, id, num) {
            const bytes = CryptoJS.AES.decrypt(val, 'ysyaes')
            const originalMessage = bytes.toString(CryptoJS.enc.Utf8)
            if (originalMessage !== `${id}${num}`) {
                this.$router.push('/not_fund')
            }
        }
    },
    computed: {
        show() {
            let name_arr = []
            let hero_ids = []
            const pre_company_name = {
                domians: [],
                default: {
                    district: '',
                    special_sigan: '',
                    industry: '',
                    organizational: ''
                }
            }
            const corporation = {
                domians: [],
                default: {
                    name: '',
                    phone: '',
                    id_card: '',
                    email: ''
                },
            }
            const supervisor = {
                domians: [],
                default: {
                    name: '',
                    phone: '',
                    id_card: '',
                    email: ''
                },
            }
            const shareholder = {
                domians: [],
                default: {
                    name: '',
                    phone: '',
                    id_card: '',
                    email: '',
                    contribution: ''
                },
            }
            const finance = {
                domians: [],
                default: {
                    name: '',
                    phone: '',
                    id_card: '',
                    email: ''
                },
            }
            const board_members = {
                domians: [],
                default: {
                    name: '',
                    phone: '',
                    id_card: '',
                    email: ''
                },
            }
            const supervisory_board = {
                domians: [],
                default: {
                    name: '',
                    phone: '',
                    id_card: '',
                    email: ''
                },
            }
            for (let key in this.computedData) {
                if (key === 'hero') {
                    this.computedData[key].map(item => {
                        name_arr.push(item.admin_user.username)
                        hero_ids.push(item.hero_id)
                    })
                } else if (key === 'pre_company' && this.computedData[key]) {
                    pre_company_name.default = this.computedData[key][0]
                    const domains = this.computedData[key].slice(1);
                    domains.map(item => {
                        pre_company_name.domians.push(item)
                    })
                } else if (key === 'corporation' && this.computedData[key]) {
                    corporation.default = this.computedData[key][0]
                    const domains = this.computedData[key].slice(1);
                    domains.map(item => {
                        corporation.domians.push(item)
                    })
                } else if (key === 'supervisor' && this.computedData[key]) {
                    supervisor.default = this.computedData[key][0]
                    const domains = this.computedData[key].slice(1);
                    domains.map(item => {
                        supervisor.domians.push(item)
                    })
                } else if (key === 'shareholder' && this.computedData[key]) {
                    shareholder.default = this.computedData[key][0]
                    const domains = this.computedData[key].slice(1);
                    domains.map(item => {
                        shareholder.domians.push(item)
                    })
                } else if (key === 'finance' && this.computedData[key]) {
                    finance.default = this.computedData[key][0]
                    const domains = this.computedData[key].slice(1);
                    domains.map(item => {
                        finance.domians.push(item)
                    })
                } else if (key === 'board_members' && this.computedData[key]) {
                    board_members.default = this.computedData[key][0]
                    const domains = this.computedData[key].slice(1);
                    domains.map(item => {
                        board_members.domians.push(item)
                    })
                } else if (key === 'supervisory_board' && this.computedData[key]) {
                    supervisory_board.default = this.computedData[key][0]
                    const domains = this.computedData[key].slice(1);
                    domains.map(item => {
                        supervisory_board.domians.push(item)
                    })
                }
            }
            return {
                name: name_arr.join('、'),
                hero: hero_ids,
                pre_company_name,
                corporation,
                supervisor,
                shareholder,
                finance,
                board_members,
                supervisory_board
            }
        }
    },
    mounted() {
        this.initData()
    }
}
</script>

<style scoped>
.reg-info-create {
    padding: 0.5rem;
}

.reg-info-create .divider-con {
    font-size: x-large;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.reg-info-create .title-sec {
    font-size: large;
}

.reg-info-create .card-container {
    background-color: #F2F6FC;
    padding: 0.3rem;
}

.reg-info-create .card-body-fir {
    display: flex;
    justify-content: space-evenly;
}

.reg-info-create .order-num {
    font-size: xx-large;
}

.reg-info-create .qc-mb {
    margin-bottom: 0.5rem;
    border-radius: 10px;
}

/* 表格 */
.reg-info-create .centered,
.t-title {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}

.reg-info-create #field-table td,
th {
    padding: 0.2rem 0.3rem;
}

.reg-info-create .corporation-table td {
    padding: 0.4rem 0.3rem;
}

.reg-info-create #show-table td {
    padding: 0.4rem 0.3rem;
}

.reg-info-create .scope-table-edit td {
    padding: 0.2rem 0.3rem;
}

.reg-info-create .reg-capital-edit td {
    padding: 0.2rem 0.3rem;
}

.reg-info-create .corporation-table-edit td {
    padding: 0.2rem 0.2rem;
}

.reg-info-create .scope-table td {
    padding: 0.4rem 0.3rem;
}

.reg-info-create .reg-capital-table td {
    padding: 0.4rem 0.3rem;
}

.reg-info-create .sco-bg {
    background-color: #EBEEF5;
}

.reg-info-create th {
    font-size: medium;
    font-weight: bold;
    background-color: #E6F3F9;

}

/* .reg-info-create .no-border {
    border: none;
} */

/* 表格end */
.reg-info-create .copy-in-l {
    display: flex;
    justify-content: flex-end;
}

.reg-info-create .ls-cap {
    font-size: large;
    font-weight: bold;
    text-align: center;
    padding: 0.2rem 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/customer/RegInfoCreate.vue